import { useEffect } from "react";
import { SITE } from "@/data/content";

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE.name,
    description: SITE.entity,
    email: SITE.email,
    url: `${SITE.domain}/`,
    logo: `${SITE.domain}/favicon.svg`,
    founder: { "@type": "Person", name: "Miro Damonson" },
    areaServed: [
        { "@type": "Country", name: "United States" },
        { "@type": "Country", name: "Canada" },
    ],
    address: { "@type": "PostalAddress", addressRegion: "OR", addressCountry: "US" },
};

export const breadcrumbSchema = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.name,
        item: `${SITE.domain}${it.path}`,
    })),
});

export default function Seo({ title, description, path = "/", jsonLd = [], noindex = false, image }) {
    useEffect(() => {
        const url = `${SITE.domain}${path}`;
        document.title = title;
        setMeta("name", "description", description);
        setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", url);
        setMeta("property", "og:type", "website");
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);
        if (image) {
            setMeta("property", "og:image", image);
            setMeta("name", "twitter:image", image);
        }
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", url);

        setMeta("property", "og:locale", "en_US");
        setMeta("property", "og:locale:alternate", "en_CA");
        document.head.querySelectorAll("link[data-seo-hreflang]").forEach((l) => l.remove());
        ["en-us", "en-ca", "x-default"].forEach((hl) => {
            const link = document.createElement("link");
            link.setAttribute("rel", "alternate");
            link.setAttribute("hreflang", hl);
            link.setAttribute("href", url);
            link.setAttribute("data-seo-hreflang", "true");
            document.head.appendChild(link);
        });

        document.head.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
        jsonLd.forEach((schema) => {
            const script = document.createElement("script");
            script.type = "application/ld+json";
            script.setAttribute("data-seo-jsonld", "true");
            script.textContent = JSON.stringify(schema);
            document.head.appendChild(script);
        });
    }, [title, description, path, noindex, image, jsonLd]);
    return null;
}
